var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodecool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0821 6.64711L31.0361 6.60815L30.9918 6.56757L30.138 5.77436L29.703 5.37073L22.7714 6.34573L4.48816 30.5303L5.47073 30.4768L27.385 28.4548L29.0412 28.2335L30.3609 28.0496L46.9874 19.854L31.0821 6.64711Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0225 5.97068L67.0182 5.92955L67.015 5.88843L66.9262 4.64993L66.8786 3.98821L61.6351 0L31.6113 4.18894L32.4651 4.98161L49.1132 18.8059L50.5157 19.8528L52.0025 20.9761L69.3232 26.8845L67.0225 5.97068Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7083 28.4786L71.9696 30.513L80.097 47.1059L93.5203 30.974L93.5382 30.9518L93.5571 30.9307L94.1533 30.2517L94.7756 29.5429L93.8698 23.2935L69.0857 4.49524L69.1744 5.73429L71.586 27.6562L71.7083 28.4786Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9745 67.122L94.0124 67.1177L94.0508 67.1145L95.1562 67.0333L95.9553 66.9743L99.9522 61.7092L95.779 31.6794L95.1832 32.3585L81.1398 49.2349L80.042 50.666L79.2385 51.7287L73.3376 69.3842L93.9745 67.122Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.21 69.2734L72.5819 71.6438L71.463 71.811L68.9027 72.1383L52.5565 80.1445L69.2544 93.5489L69.2858 93.5743L69.3155 93.6003L69.9286 94.1305L70.7331 94.8269L76.4744 93.9974L95.3154 69.1917L94.21 69.2734Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8996 95.2365L50.4091 81.1964L49.6981 80.6629L48.0755 79.4092L30.6364 73.6106L32.529 94.2512L32.5328 94.2913L32.535 94.3313L32.5837 95.2257L32.634 96.1633L37.694 100L68.5127 95.7667L67.8996 95.2365Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3943 72.8655L28.1313 70.8998L27.8749 69.0543L19.8059 52.641L6.61254 69.1035L6.58711 69.1354L6.56005 69.1657L5.85288 69.9827L5.32263 70.5958L6.23108 77.0756L30.4227 95.3431L30.374 94.4487L28.3943 72.8655Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6693 32.6323L5.62873 32.636L5.58814 32.6382L4.60556 32.6912L3.75988 32.7372L0 37.7048L4.21654 68.5667L4.92371 67.7497L18.7512 50.4961L19.2322 49.8485L20.81 47.8059L26.6227 30.6985L5.6693 32.6323Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodecool);
export default __webpack_public_path__ + "static/media/codecool.fa7a75ac0eac8a8b59ebd99be6277e92.svg";
export { ForwardRef as ReactComponent };